import * as api from '../api';

const createNewSessionActions = api.fetchActions('login', 'create-new-session');

export const actionTypes = {
  ...createNewSessionActions.actionTypes,
};

export const createNewSession = (email, password) =>
  api.postThunk('/sessions', { email, password }, createNewSessionActions, {}, api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/login/login.actions.js